import { useQuery } from "@tanstack/react-query";
import { restApiRequest, SUBSCRIPTION_MANAGEMENT_SERVICE } from "src/utils/Api";
import mockBenefitsData from "src/Pages/Company/Products/Subscriptions/utils/mockBenefitsData";
import sortByField from "src/utils/jsHelpers/sortByField";

const useCompanyBenefits = (
  companyId: string,
  enabled: boolean,
  asOptions: boolean
) =>
  useQuery({
    enabled,
    queryKey: [
      "subscription-management-benefits",
      { companyId, itemsPerPage: 10000 },
    ],
    queryFn: () =>
      restApiRequest(
        SUBSCRIPTION_MANAGEMENT_SERVICE,
        `/benefits?itemsPerPage=10000&companyId=${companyId}`,
        "GET",
        {},
        mockBenefitsData
      ),
    select: (
      data: {
        id: string;
        name: string;
      }[]
    ) =>
      asOptions
        ? sortByField(
            data?.map(({ name, id }) => ({
              value: id,
              label: name,
            })) || [],
            "label"
          )
        : data,
  });

export default useCompanyBenefits;
